import 'web-animations-js';
import Misc from './misc';

class TabsWrapper {
  constructor(options) {

    // Wrapper
    this.mobileLayout = Misc.getMediaQueries()['mobile-layout'];
    this.wrapper = document.querySelector(options.wrapper);

    if (!this.wrapper) { return false; }


    // Elements to handle
    this.navList = this.wrapper.querySelectorAll('.tabs--item');
    this.contentList = this.wrapper.querySelectorAll('.tabs--content');

    // Methods
    this.handleTabNav = this.handleTabNav.bind(this);
    this.closeTab = this.closeTab.bind(this);
    this.handleOnResize = this.handleOnResize.bind(this);
    
    // Initial Setup when page loads
    this.setOnDocumentReady();

    [].slice.call(this.navList).forEach(item => {
      item.addEventListener('click', this.handleTabNav);
    });

    window.addEventListener('resize', this.handleOnResize);

  }

  handleTabNav(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // handle on Mobile
    if (Misc.getViewport().width <= this.mobileLayout) {
      this.handleOnMobile(event);
    } else {
      this.handleOnNonMobile(event);
    }

  }

  handleOnNonMobile(event) {

    const targetIndex = Array.prototype.indexOf.call(event.currentTarget.parentElement.children, event.currentTarget);
    const tabReference = event.currentTarget.getAttribute('data-ref');
    const activeTarget = this.wrapper.querySelector('.tabs--content.active');

    if (event.currentTarget.classList.contains('active')) {
      return false;
    }

    [].slice.call(this.navList).forEach((item, index) => {
      item.classList.remove('active');
    });

    this.closeTab(activeTarget);
    this.openTab(this.wrapper.querySelector(`.tabs--content[data-ref="${tabReference}"]`));
    event.currentTarget.classList.add('active');
  }

  handleOnMobile(event) {
    const targetIndex = Array.prototype.indexOf.call(event.currentTarget.parentElement.children, event.currentTarget);
    const tabReference = event.currentTarget.getAttribute('data-ref');

    if (!this.contentList[targetIndex].classList.contains('active')) {
      this.wrapper.querySelector(`.tabs--item[data-ref="${tabReference}"]`).classList.add('active');
      this.openTab(this.wrapper.querySelector(`.tabs--content[data-ref="${tabReference}"]`));
    } else {
      this.wrapper.querySelector(`.tabs--item[data-ref="${tabReference}"]`).classList.remove('active');
      this.closeTab(this.contentList[targetIndex]);
    }

  }

  handleOnResize() {
    let activeTabs = [].slice.call(this.navList).filter( item => item.classList.contains('active')).length;
    

    if (!Misc.isMobileLayout() && activeTabs === 0 ) {
      [].slice.call(this.navList)[0].classList.add('active');
      [].slice.call(this.contentList)[0].classList.add('active');
      this.openTab(this.wrapper.querySelector('.tabs--content'));
    }

    if (!Misc.isMobileLayout() && activeTabs > 1 ) {
      [].slice.call(this.navList).filter( item => item.classList.remove('active'));
      [].slice.call(this.contentList).filter( item => {
        item.classList.remove('active');
        item.removeAttribute('style');
      });
      this.openTab(this.wrapper.querySelector('.tabs--content'));
    }

  }

  // document.addEventListener('DOMContentLoaded', fn);
  setOnDocumentReady() {

    if (Misc.getViewport().width > this.mobileLayout) {
      [].slice.call(this.navList)[0].classList.add('active');
      [].slice.call(this.contentList)[0].classList.add('active');
      // Open first tab on load
      this.openTab(this.wrapper.querySelector('.tabs--content'));
    };

    if (Misc.getViewport().width < this.mobileLayout) {
      [].slice.call(this.navList)[0].classList.remove('active');
      document.querySelector('.tabs--content-buying').classList.remove('active');
    }

  }

  closeTab(target) {
    const isMobile = Misc.getViewport().width < Misc.getMediaQueries()['mobile-layout'];
    const targetHeight = parseInt(target.getBoundingClientRect().height);
    let animationKeyFrames = {
      opacity: [1, 0]
    };

    if (isMobile) {
      animationKeyFrames = Object.assign(animationKeyFrames, {
        height: [`${targetHeight}px`, 0],
        opacity: [1, 1],
      });
    };

    const targetAnimation = target.animate(animationKeyFrames, {
      duration: 100, 
      fill: 'forwards',
      easing: 'ease-in-out'
    });
    targetAnimation.onfinish = () => {
      target.style.removeProperty('height');
      target.style.removeProperty('z-index');
      target.style.removeProperty('opacity');
      target.classList.remove('active');
      targetAnimation.cancel();
    }
  }

  openTab(target) {

    const targetHeight = parseInt(target.querySelector('.tabs--content-inner').getBoundingClientRect().height);
    const isMobile = Misc.getViewport().width < Misc.getMediaQueries()['mobile-layout'];
    
    let animationKeyFrames = {
      opacity: [0, 1],
    };
    
    if (isMobile) {
      animationKeyFrames = Object.assign(animationKeyFrames, {
        opacity: [1, 1],
        height: [0, `${targetHeight}px`],
      });
    }

    const targetAnimation = target.animate(animationKeyFrames, {
      duration: 300,
      fill: 'forwards',
      easing: 'ease-in-out'
    });

    targetAnimation.onfinish = () => {
      target.classList.add('active');
      target.style.setProperty('opacity', 1);
      target.style.setProperty('z-index', 100);
      if (isMobile) {
        target.style.setProperty('height', `${targetHeight}px`);
        if (document.querySelector('.tabs--item.active').getBoundingClientRect().y < 0) {
          let offset = document.querySelector('.tabs--item.active').getBoundingClientRect().height + document.querySelector('.site-header').getBoundingClientRect().height;
          Misc.scrollTo2(target, 300, parseInt(offset));
        }
      }
      targetAnimation.cancel();
    }
  }

};

new TabsWrapper({
  wrapper: '#front-page-tabs'
});